// extracted by mini-css-extract-plugin
export default {"productDescription":"mba-z","featuredDescription":"nba-z","description":"oba-z","more":"pba-z","descriptionSku":"qba-z"};